var STRUCTURAL_CLASSES = {
  Element: true,
  Dataset: true
};

function isCallingContext(record) {
  if (!record || typeof record.name !== 'string') return false;
  if (record.name === 'root' || record.name[0] === '-') return false;
  return !STRUCTURAL_CLASSES[record['@class']];
}

function isLeafContext(record) {
  return record &&
    typeof record.name === 'string' &&
    record.name[0] !== '-' &&
    STRUCTURAL_CLASSES[record['@class']];
}

function fromOriginColumn(pointRecord, originColumn) {
  var originPath = Array.isArray(originColumn && originColumn.path)
    ? originColumn.path
    : [];

  if (!originPath.length) return null;

  var path = originPath.filter(isCallingContext);
  var leafLabels = originPath.filter(isLeafContext).map(function (record) {
    return record.name;
  });
  if (originColumn.name) leafLabels.push(originColumn.name);

  var titleRecord = Object.assign({}, pointRecord, {
    name: leafLabels.join(' - ') || pointRecord.name
  });

  return {
    path: path.concat([titleRecord]),
    record: titleRecord
  };
}

module.exports = {
  fromOriginColumn: fromOriginColumn
};
